// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/.pnpm/css-loader@6.9.1_webpack@5.90.0/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/.pnpm/css-loader@6.9.1_webpack@5.90.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wbbQZcoezJtHJv5oboIM{width:100%;height:100%;display:flex;justify-content:center;align-items:center}.wbbQZcoezJtHJv5oboIM .PPbzV3MChTljNUYAuK34{max-width:1024px;width:100%;height:100%;display:flex;align-items:center;flex-direction:row}.wbbQZcoezJtHJv5oboIM .PPbzV3MChTljNUYAuK34 .SHiu7l50Xpy0yTccWXYY{height:fit-content}.wbbQZcoezJtHJv5oboIM .PPbzV3MChTljNUYAuK34 .TLaPRGqWdssDYI5CJR9c{flex:1;display:flex;flex-direction:column;justify-content:center;align-items:center;width:100%;height:100%}.wbbQZcoezJtHJv5oboIM .PPbzV3MChTljNUYAuK34 .OpF3unaFCT4HLbLBhgxE{display:flex;flex-direction:row;height:100%}.wbbQZcoezJtHJv5oboIM .PPbzV3MChTljNUYAuK34 .OpF3unaFCT4HLbLBhgxE .muEIJTqIj623qt8Q0TOS{flex:1 1 50%}.wbbQZcoezJtHJv5oboIM .PPbzV3MChTljNUYAuK34 .OpF3unaFCT4HLbLBhgxE .IxT73A7MnkoID8fkPY58{height:100%;width:100%}.wbbQZcoezJtHJv5oboIM .PPbzV3MChTljNUYAuK34 .jEKh8cEOOxbX9bmz8LQl{display:flex;justify-content:space-between;align-items:center;flex-direction:row}.wbbQZcoezJtHJv5oboIM .PPbzV3MChTljNUYAuK34 .RirNHzEhQgbHHnfwWqZL{display:flex;justify-content:center;align-items:center;margin-top:1em}.wbbQZcoezJtHJv5oboIM .PPbzV3MChTljNUYAuK34 h3{color:#6e32f0;text-align:center;font-size:15px;font-weight:600;margin-bottom:2rem;letter-spacing:.6rem;text-transform:uppercase}.wbbQZcoezJtHJv5oboIM .PPbzV3MChTljNUYAuK34 h4{font-weight:600;flex:1}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"primary-dark": `#e73b05`,
	"primary": `#ff6040`,
	"primary-light": `#ffe4df`,
	"primary-extra-light": `#fff2f0`,
	"secondary-dark": `#8292b1`,
	"secondary": `#99a8c6`,
	"secondary-light": `#d0dae9`,
	"secondary-extra-light": `#eef4fc`,
	"default-dark": `#898ca7`,
	"default": `#b8baca`,
	"default-light": `#ecedf5`,
	"default-extra-light": `#f8f8f8`,
	"warning-dark": `#d96800`,
	"warning": `#fbab00`,
	"warning-light": `#ffeba3`,
	"warning-extra-light": `#fff5d1`,
	"info-dark": `#0a82c6`,
	"info": `#2eb6ea`,
	"info-light": `#beebfc`,
	"info-extra-light": `#dff5fe`,
	"success-dark": `#069941`,
	"success": `#3aaa35`,
	"success-light": `#c6f1c3`,
	"success-extra-light": `#e3f9e1`,
	"danger-dark": `#cd0101`,
	"danger": `#ff4141`,
	"danger-light": `#ffcece`,
	"danger-extra-light": `#ffe7e7`,
	"text-primary": `#131a4f`,
	"text-secondary": `#8292b1`,
	"shadow-25": `rgba(184,186,202,.25)`,
	"shadow-50": `rgba(184,186,202,.5)`,
	"root": `wbbQZcoezJtHJv5oboIM`,
	"rightComponent": `PPbzV3MChTljNUYAuK34`,
	"oneColumn": `SHiu7l50Xpy0yTccWXYY`,
	"carouselItem": `TLaPRGqWdssDYI5CJR9c`,
	"twoColumns": `OpF3unaFCT4HLbLBhgxE`,
	"column": `muEIJTqIj623qt8Q0TOS`,
	"image": `IxT73A7MnkoID8fkPY58`,
	"titleWithButton": `jEKh8cEOOxbX9bmz8LQl`,
	"centeredButton": `RirNHzEhQgbHHnfwWqZL`
};
export default ___CSS_LOADER_EXPORT___;
